import { Button, ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';

export default function createNew() {
    return (
        <>
            <div>
                <Dropdown as={ButtonGroup}>
                    <Button variant='danger' className="Univers-BoldCondensed">
                        <FontAwesomeIcon icon={faPenToSquare} className="mr-2" />
                        CREATE NEW
                    </Button>
                    <DropdownToggle split variant='danger' id="dropdown-split-basic" />
                    <DropdownMenu>
                        <DropdownItem href='/shortStory'>Create Short Story</DropdownItem>
                        <DropdownItem href='/longStory'>Create Long Story</DropdownItem>
                        <DropdownItem href='/community'>Create Community</DropdownItem>
                        <DropdownItem href='/video'>Create Video</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </>
    )
}